import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-header">
        <Link to="/company" className="back-link">← Back to Home</Link>
      </div>

      <div className="privacy-policy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: Sep 2025</p>

        <section className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>
            We collect information you provide directly to us, such as when you create an account,
            submit your website URL, or contact us for support. This may include:
          </p>
          <ul>
            <li>Email address</li>
            <li>Company website URL</li>
            <li>Creator Information</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our AI influencer marketing services</li>
            <li>Connect you with relevant influencers</li>
            <li>Send you technical notices and support messages</li>
            <li>Respond to your comments and questions</li>
            <li>Analyze and improve our platform's performance</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Information Sharing</h2>
          <p>
            We do not sell, trade, or rent your personal information to third parties.
            We may share your information only in the following circumstances:
          </p>
          <ul>
            <li>With influencers for collaboration purposes (with your consent)</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and prevent fraud</li>
            <li>With your consent or at your direction</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect
            your personal information against unauthorized access, alteration, disclosure,
            or destruction.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Request deletion of your data</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of
            any changes by posting the new Privacy Policy on this page and updating the
            "Last updated" date.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;